export enum LogisticsAreaType
{
	UNDEF = 'UNDEF',
	ARTICLE = 'ARTICLE',
	CUSTOMER = 'CUSTOMER'
}